module.exports = __webpack_public_path__ + "static/media/talent-feature-interview-reminder.59623066.png";